import { SelectedTargets } from '../../../targets/type';
import { CompanyData } from '../../common/types/CompanyData';
import { AccountSourceId } from '../../common/types/AccountSources';
import { Rights } from '../../common/accountRoleAndPrivileges/type';

export enum CreateAccountEvents {
  InitCreateAccountForm = 'initCreateAccountForm',
  AccountCreated = 'accountCreated',
  Cancel = 'cancelCreateAccount',
}

export interface LoggedInUserData {
  _id?: string;
  adIntegration?: boolean;
  companyInfo?: CompanyData;
  profile?: {
    timezone?: string;
    language?: string;
  };
  serviceTargets?: SelectedTargets;
  source?: AccountSourceId;
}

export interface NewAccount {
  userName: string;
  email: string;
  active: string;
  created: null;
  readOnly: boolean;
  password: string;
  profile: Profile;
  phoneNumber: PhoneNumber;
  source: AccountSourceId;
  company: Company;
  role: Role;
  accountLockdown?: LockDown;
  concurrentSessions?: ConcurrentSessions;
  passwordLifetime?: boolean;
  serviceTargets: SelectedTargets;
}

interface ConcurrentSessions {
  enabled: boolean;
}

interface Profile {
  fullName: string;
  timezone: string;
  language: string;
}

interface PhoneNumber {
  countryCode: string;
  subscriberNumber: string;
}

interface Company {
  id: string;
}

interface Role {
  roleId: string | null;
  rights: Rights;
}

interface LockDown {
  enabled: boolean;
}
